import { render, staticRenderFns } from "./DashboardWeeklyOverview.vue?vue&type=template&id=834fe50a"
import script from "./DashboardWeeklyOverview.vue?vue&type=script&lang=js"
export * from "./DashboardWeeklyOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports